import { render, staticRenderFns } from "./StateDetail.vue?vue&type=template&id=2ff9828a&scoped=true"
import script from "./StateDetail.vue?vue&type=script&lang=ts"
export * from "./StateDetail.vue?vue&type=script&lang=ts"
import style0 from "./StateDetail.vue?vue&type=style&index=0&id=2ff9828a&lang=scss"
import style1 from "./StateDetail.vue?vue&type=style&index=1&id=2ff9828a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff9828a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/CONA-CRM/Admin/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ff9828a')) {
      api.createRecord('2ff9828a', component.options)
    } else {
      api.reload('2ff9828a', component.options)
    }
    module.hot.accept("./StateDetail.vue?vue&type=template&id=2ff9828a&scoped=true", function () {
      api.rerender('2ff9828a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/locations/states/components/StateDetail.vue"
export default component.exports